import { useMemo, useState } from 'react';

import { Box, Flex, rem } from '@vimeo/bokeh';
import { usePolls } from '@vimeo/live-core/store/firebase/interaction/poll';
import { IPollPanel, TPollsList } from '@vimeo/live-core/types/interaction_tools';

import { translations } from '../../../../translations';

export function usePollPanels(polls: TPollsList) {
  const [activePanelId, setActivePanelId] = useState<number>(0);

  const { activePolls, archivedPolls } = usePolls(polls);

  const panels: Array<IPollPanel> = useMemo(
    () => [
      {
        id: 0,
        label: (
          <Flex gap={rem(4)}>
            <Box>{translations.active}</Box>
            <Box color={'text-secondary'}>{activePolls.length || null}</Box>
          </Flex>
        ),
        polls: activePolls,
      },
      {
        id: 1,
        label: (
          <Flex gap={rem(4)}>
            <Box>{translations.archived}</Box>
            <Box color={'text-secondary'}>{archivedPolls.length || null}</Box>
          </Flex>
        ),
        polls: archivedPolls,
      },
    ],
    [activePolls, archivedPolls],
  );

  return { panels, activePolls, archivedPolls, activePanelId, setActivePanelId };
}
